'use client';
'use strict';

function isSameMonth(date, comparison) {
  return date.getFullYear() === comparison.getFullYear() && date.getMonth() === comparison.getMonth();
}

exports.isSameMonth = isSameMonth;
//# sourceMappingURL=is-same-month.cjs.map
